import { useLayout } from "@/lib/contexts/layout.context";
import { useEffect } from "react";

/**
 * Taxpeer loading spinner.
 * @returns
 */
const LoadingSpinner = () => {
	// hide navigation bar
	const { setShowNavbar } = useLayout();

	useEffect(() => {
		setShowNavbar(false);

		// Cleanup function to restore navbar when component unmounts
		return () => {
			setShowNavbar(true);
		};
	}, []);

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
			{/* biome-ignore lint/a11y/noSvgWithoutTitle: <explanation> */}
			<svg
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				viewBox="0 0 500 500"
				shapeRendering="geometricPrecision"
				textRendering="geometricPrecision"
				className="w-24 h-24"
				aria-label="Loading..."
			>
				<g clipPath="url(#clipPath)">
					<g transform="matrix(.845906 0 0 0.845906 38.5235 38.5235)">
						<path
							d="M0,0v233L233.5,0L0,0Z"
							fill="#3a526e"
							className="animate-piece1"
						/>
						<path
							d="M429,0L263.5,165.5L500,401.099L500,0h-71Z"
							transform="matrix(1.182163 0 0 1.182163-45.54075-45.54075)"
							fill="#269f9a"
							className="animate-piece2"
						/>
						<path
							d="M0,429L163.5,265.5L403.159,500L0,500v-71Z"
							fill="#269f9a"
							className="animate-piece3"
						/>
					</g>
					<clipPath id="clipPath">
						<rect width="500" height="500" rx="0" ry="0" fill="#fff" />
					</clipPath>
				</g>
				<style>{`
                      .animate-piece1 {
                          animation: scale1 1s infinite;
                          transform-origin: 250px 250px;
                      }
                      
                      .animate-piece2 {
                          animation: scale2 1.8s infinite;
                          transform-origin: 250px 250px;
                      }
                      
                      .animate-piece3 {
                          animation: scale3 1s infinite;
                          transform-origin: 250px 250px;
                      }
                      
                      @keyframes scale1 {
                          0% { transform: scale(1); }
                          60% { transform: scale(1.182164); }
                          100% { transform: scale(1); }
                      }
                      
                      @keyframes scale2 {
                          0% { transform: matrix(1.182163, 0, 0, 1.182163, -45.54075, -45.54075); }
                          22% { transform: matrix(0.999962, 0, 0, 0.999962, -45.54075, -45.54075); }
                          67% { transform: matrix(1, 0, 0, 1, -45.54075, -45.54075); }
                          100% { transform: matrix(1.182166, 0, 0, 1.182166, -45.54075, -45.54075); }
                      }
                      
                      @keyframes scale3 {
                          0% { transform: scale(1); }
                          75% { transform: scale(1.182164); }
                          100% { transform: scale(1); }
                      }
                  `}</style>
			</svg>
		</div>
	);
};

export default LoadingSpinner;
